module.exports = __webpack_public_path__ + "static/churchloopmobile-602c21f369c24f0631f2c55fdb05390a.png";